

import {
    MainContainer,
    ContentContainer,
    Text
} from '../../../styles/component.styles';

const AddTheme = () => {

    return (
        <MainContainer>
            <ContentContainer>
                <Text>Add Theme</Text>
            </ContentContainer>
        </MainContainer>
    )
}

export default AddTheme;